import { UserCircle } from 'lucide-react';

import type { RouteListItem } from '@/types';

export const domainsSubNav: RouteListItem[] = [
  {
    path: '/domains/$id',
    icon: UserCircle,
    name: 'Domain',
  },
];
